<template lang="pug">
  #app(v-on:keydown.stop.prevent="add" v-on:touchstart.stop.prevent="addRandom" oncontextmenu="return false;" tabindex="0")
    header.app-header
      button.about-btn-l(v-on:click="showModal") このページについて
      a.about-btn-m
    h1.app-title {{ $store.state.title }}
    p.app-description {{ $store.state.description }}
    AnimalList
    a.attribution(href="https://www.freepik.com/free-photos-vectors/hand" tabindex="-1") Hand vector created by freepik - www.freepik.com
    modal(name="about" width="80%" height="50%" classes="about-modal v--modal")
      p {{ $store.state.modalText }}

</template>

<script>
import AnimalList from '@/components/AnimalList.vue'
import { mapActions } from 'vuex'

export default {
  name: 'app',
  methods: {
    ...mapActions([
      'addAnimal',
    ]),
    add: function (event) {
      this.addAnimal(event.key)
    },
    addRandom: function () {
      const keys = Object.keys(this.$store.state.keyAnimalMap)
      this.addAnimal(keys[Math.floor(Math.random() * keys.length)])
    },
    showModal () {
      this.$modal.show('about');
    },
    hideModal () {
      this.$modal.hide('about');
    }
  },
  components: {
    AnimalList
  }
}
</script>

<style lang="stylus" scoped>
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  height 100%
  width 100%
  display flex
  flex-direction column

  &:focus
    outline none

.app-header
  display flex
  padding 8px

button
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;


.about-btn-l
  @media screen and (max-width: 768px)
    display none

.about-btn-m
  @media screen and (min-width: 768px)
    display none

.app-title
  padding-top 60px

.app-description
  @media screen and (max-width: 768px)
    display none

.attribution
  font-size 12px
  padding-bottom 16px
  text-decoration none
  color #2c3e50
  position absolute
  top 95%
  left 0
  right 0
  margin 0 auto
  z-index -1
</style>

<style lang="stylus">
body
  margin 0
  padding 0
  border 0
  outline 0

.about-modal
  padding 16px
  display flex
  align-items center
  justify-content center
</style>